export class DetalleTransaccion {
    public transaccionId: number;
    public nombre: string;
    public sNombre: string;
    public apellidoPaterno: string;
    public apellidoMaterno: string;
    public instrumento: string;
    public referencia: string;
    public fechaRegistro: string;
    public tipoCambioDof: string;
    public tipoCambioFix: string;
    public tipoCambioObl: string;
    public tipoOperacion: string;
    public sucursal: string;
    public insitucionFinanciera: string;
    public divisa: string;
    public noCheque: string;
    public saldo: string;
    public tFechaPago: string;
    public tMontoTotal: string;
    public diasTranscurridos: number;
    public totalRegistros: number;
    public contrato: string;
    public latitud: number;
    public longitud: number;
    public estadoGeolocaliza: string;
    public municipioGeolocaliza: string;
    public localidadGeolocaliza: string;
    public perfil: any;
    public producto: any;
    public esCancelada: number;
    public tipoOpervw: string;
    public bancoOrigenTran: string;
    public cuentaOrigen: string;
    public nombreOrigen: string;
    public contraparte: string;
    public numeroCuenta: string;
    public banco: string;
    public seleccionado: number;
    public CasoId: number;
    public clavecia: string;
    public siprev: string;
    public geolocalizacionPago: string;
    public ultimaTransaccion: number;
    public institucionFinanciera: string;
    public cuentaClabe: string;
    public entradaSalida: number;
    public tipoAfectacion: string;
    public formaDePago: number;
    public tipoPago: string;
    public clearingDoc: string;
    public marca: string;
    public auto: string;
    public modelo: number;
    public chasis: string;
    public cargosAdicionales: string;
    public montoNeto: string;
    public facturaNumero: number;
    public documentoFecha: string;
    public documentoNumero: number;
    public base: string;
    public rfc: string;
    public pais: string;
    public saldoCredito: string;
    public tipoTarjeta: string;
    public canal: string;
    public estatus: string;
    public personalidadFiscal: string;
    public paisContraparte: string;
    public contraparteCuentaClabe: string;
    public contraparteNombre: string;

    constructor() {
        this.transaccionId = 0;
        this.nombre = '';
        this.sNombre = '';
        this.apellidoPaterno = '';
        this.apellidoMaterno = '';
        this.instrumento = '';
        this.referencia = '';
        this.fechaRegistro = '';
        this.tipoCambioDof = '';
        this.tipoCambioFix = '';
        this.tipoOperacion = '';
        this.sucursal = '';
        this.insitucionFinanciera = '';
        this.divisa = '';
        this.noCheque = '';
        this.saldo = '';
        this.tFechaPago = '';
        this.tMontoTotal = '';
        this.diasTranscurridos = 0;
        this.totalRegistros = 0;
        this.contrato = '';
        this.esCancelada = 0;
        this.tipoOpervw = '';
        this.bancoOrigenTran = '';
        this.cuentaOrigen = '';
        this.nombreOrigen = '';
        this.siprev = '';
        this.marca = '';
        this.auto = '';
        this.modelo = 0;
        this.chasis = '';
        this.cargosAdicionales = '';
        this.montoNeto = '';
        this.facturaNumero = 0;
        this.documentoFecha = '';
        this.documentoNumero = 0;
        this.base = '';
        this.rfc = '';
        this.pais = '';
        this.saldoCredito = '';
        this.tipoTarjeta = '';
        this.canal = '';
        this.estatus = '';
        this.personalidadFiscal = '';
        this.paisContraparte = '';
        this.contraparteCuentaClabe = '';
        this.contraparteNombre = '';
    }
}
